import { Component, OnInit } from '@angular/core';
import { ZpDataService } from '../services/zp-data.service';
import { NotificationService } from '../services/notification.service';
import { ZPNotification } from '../models/zpnotification';
import { SideNavBarVisibilityService } from '../services/side-nav-bar-visibility.service';
import { IDataEntryForm } from '../models/data-entry.model';
import { IUser } from '../models/user.model';
import { ThemeService } from '../theme/theme-service.service';

@Component({
    selector: 'app-deleted-items',
    templateUrl: './deleted-items.component.html',
    styleUrls: ['./deleted-items.component.scss'],
    standalone: false
})
export class DeletedItemsComponent implements OnInit {
  public noItemDeleted = false;
  public dataIsLoaded: boolean = false;
  public myItem = {};
  public lastUpdateByName: any;
  public myUser: IUser;
  public Id;
  public myFormTemplate: IDataEntryForm;
  public user: any;
  public delegateUser: any;
  public lastUpdateByDelegateName: any;
  public statusExplanations;
  public activeTheme: any;
  public isDefaultTheme: boolean;

  constructor(
    private ZpDataService: ZpDataService,
    private notificationService: NotificationService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    public themeService: ThemeService) { }

  public deletedItems = { results: [] };

  async ngOnInit() {
    this.activeTheme = this.themeService.active
    if (this.activeTheme.name != 'defaultTheme') {
      this.isDefaultTheme = false;
    }
    await this.refresh();
    this.deletedItems.results.forEach(element => {
      this.user = element
      this.delegateUser = element.data
    });
    if (this.deletedItems.results.length > 0) {
      this.lastUpdateByName = await this.ZpDataService.getUserName(this.user["user"]);
      this.lastUpdateByDelegateName = await this.ZpDataService.getUserName(this.delegateUser["delegate"]);
    }
  }

  async refresh() {
    this.dataIsLoaded = false;
    this.deletedItems = await this.ZpDataService.getDeletedItems();
    if (this.deletedItems.results.length == 0) {
      this.noItemDeleted = true;
    } else {
      this.noItemDeleted = false;
    }
    this.dataIsLoaded = true;
  }

  async restore(id) {
    this.deletedItems.results.map(async item => {
      if (item._id === id) {
        let r = await this.ZpDataService.updateItem(item.data.item[0], item.section, item.user);
        if (r) {
          let r = await this.ZpDataService.permanentlyDeleteDeletedItem(id, true);
          if (r) {
            this.notificationService.changeMessage(new ZPNotification("Item restored.", undefined, undefined, "The Item was restored to your zenplan."));
          } else {
            this.notificationService.changeMessage(new ZPNotification("Item not restored.", undefined, undefined, "The Item was not restored. An error occurred. Please contact support. (1)"));
          }
        } else {
          this.notificationService.changeMessage(new ZPNotification("Item not restored.", undefined, undefined, "The Item was not restored. An error occurred. Please contact support. (2)"));
        }
        this.refresh();
      }
    })
  }

  async permanentDelete(id) {
    let success = await this.ZpDataService.permanentlyDeleteDeletedItem(id);
    if (success) {
      this.notificationService.changeMessage(new ZPNotification("Item deleted.", undefined, undefined, "The Item was permanently deleted. You will need to re-enter it by hand if you would like to restore it to your plan."));
      this.refresh();
    }
  }

}
